export default {
  ptIssue: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};
